import { P } from '../ui';
import content from '../../content';
import type { PageInformation } from '../../config/types';
import { parseSafeHtml } from '../../utils/safe-html';

export default function InformationPageTemplate({
  config,
  onContinue,
  disabled,
}: {
  config: PageInformation;
  onContinue: () => void;
  disabled?: boolean;
}) {
  return (
    <>
      {(config.description ?? '').split('\n').map((paragraph) => (
        <P key={paragraph.substring(0, 20)}>{parseSafeHtml(paragraph)}</P>
      ))}
      <button
        data-testid="information-continue-btn"
        className="govuk-button"
        data-module="govuk-button"
        data-prevent-double-click="true"
        onClick={onContinue}
        type="button"
        disabled={disabled ?? false}
      >
        {content.buttonContinue}
      </button>
    </>
  );
}
